<template>
	<div>
		<div class="container-fluid container-froDesk">
			<div class="wrapper">
				<div class="content-page content-froDesk">
					<div class="content">
						<div class="row">
							<!-- 在研课题 -->
							<div class="col-lg-12">
								<div class="card">
									<div class="card-body">
										<!-- 筛选top -->
										<div class="conditionTop mt-n2 clearfix">
											<div class="conditionLeft mb-n2">
												<form>
													<div class="form-row ml-0 mr-0">
														<div class="form-row ml-0 mr-0 pt-2">
															<div class="form-group">
																<!-- <label for="inputState" class="col-form-label">关键字：</label> -->
																<input type="search" class="form-control" id="inputState" placeholder="请输入标题" />
															</div>
															<div class="form-group">
																<!-- <label for="inputResults" class="col-form-label">成果形式：</label> -->
																<select id="inputResults" class="form-control">
																	<option>-请选择成果形式-</option>
																	<option>成果形式 1</option>
																	<option>成果形式 2</option>
																	<option>成果形式 3</option>
																</select>
															</div>
															<div class="form-group">
																<!-- <label for="inputDate" class="col-form-label">年度：</label> -->
																<input
																	type="text"
																	class="form-control"
																	id="inputDate"
																	data-provide="datepicker"
																	data-date-format="yyyy年"
																	data-date-min-view-mode="2"
																	placeholder="选择获奖年度"
																/>
															</div>
															<!-- <div class="form-group">
                                                            <label for="inputResults" class="col-form-label">使用群体：</label>
                                                            <select id="inputResults" class="form-control">
                                                                <option>-全部-</option>
                                                                <option>使用群体 1</option>
                                                                <option>使用群体 2</option>
                                                                <option>使用群体 3</option>
                                                            </select>
                                                        </div> -->
															<div class="form-group">
																<!-- <label class="col-form-label" style="opacity: 0;">搜索:</label> -->
																<button type="button" class="btn btn-success form-control" @click="toPage('searchList')">搜索</button>
															</div>
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card-->
							</div>
							<!-- end 在研课题-->
						</div>
						<div class="row">
							
							<!-- 科研论文 -->
							<div class="col-lg-6">
								<div id="card-left-1" class="card">
									<div class="card-body card-body1">
										<div class="dropdown float-right" @click="goPapersList(18)">
											<a href="javascript: void(0);" class="dropdown-toggle arrow-none" title="更多"><i class="mdi mdi-chevron-right-box-outline"></i></a>
										</div>
										<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
											<span class="tit">科研论文</span>
											<span class="ml-1">Paper Of Research</span>
										</h3>
										<ul class="froDesk-Lists">
											<!-- <li class="li_1">
												<i class="mdi mdi-arrow-right"></i>
												<a href="">区委副书记、区长薛侃带队调研内江路小学迁建工程区委副书记、区长薛侃带队调研内江路小学迁建工程</a>
												<span class="time">01-27</span>
											</li> -->
											<li class="li_1" v-for="(item,index) in researchPaperList" :key="index" @click="goArticleDetail(item.id)">
												<i class="mdi mdi-arrow-right"></i>
												<a href="javascript: void(0);">{{item.title}}</a>
												<span class="time">{{item.createTime|getMMddTime}}</span>
											</li>
										</ul>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card-->
							</div>
							<!-- end 科研论文-->
							
							<!-- 获奖成果 -->
							<div class="col-lg-6">
								<div id="card-right-1" class="card">
									<div class="card-body card-body1">
										<div class="dropdown float-right" @click="goPapersList(19)">
											<a href="javascript: void(0);" class="dropdown-toggle arrow-none" title="更多"><i class="mdi mdi-chevron-right-box-outline"></i></a>
										</div>
										<h3 class="header-title froDeskHeader-tit mb-3 pb-2">
											<span class="tit">获奖成果</span>
											<span class="ml-1">Awarded Results</span>
										</h3>

										<ul class="froDesk-Lists">
											<!-- <li class="li_1">
												<i class="mdi mdi-arrow-right"></i>
												<a href="resultsDetails">区委副书记、区长薛侃带队调研内江路小学迁建工程区委副书记、区长薛侃带队调研内江路小学迁建工程</a>
												<span class="time">01-27</span>
											</li> -->
											<li class="li_1" v-for="(item,index) in awardedResearchProduct" :key="index" @click="goArticleDetail(item.id)">
												<i class="mdi mdi-arrow-right"></i>
												<a href="javascript: void(0);">{{item.title}}</a>
												<span class="time">{{item.createTime|getMMddTime}}</span>
											</li>
										</ul>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card-->
							</div>
							<!-- end 获奖成果-->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getColumnList } from '@/api/before/home.js'
export default {
	name: 'researchResults',
	data() {
		return {
			researchPaperList:[],//科研论文
			awardedResearchProduct:[],//获奖成果
		};
	},
	created() {
		this.getAwardedResearchProduct()
		this.getResearchPaperList()
	},
	methods: {
		// 跳转到文章详情
		goArticleDetail(id){
			this.$router.push('/publicDetails/'+id)
		},
		// 跳转到可以论文列表
		goPapersList(id){
			let query = {
				columnId:id
			}
			this.$router.push({path:'/papersList',query})
		},
		// 获取科研论文文章
		async getResearchPaperList(){
			let params = {
			  "id": 18,
				"pageNumber": 1,
				"pageSize": 9,
			}
			const res = await getColumnList(params)
			if (res.code == 200) {
				this.researchPaperList = res.data.records
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取获奖成果
		async getAwardedResearchProduct(){
			let params = {
			  "id": 19,
				"pageNumber": 1,
				"pageSize": 9,
			}
			const res = await getColumnList(params)
			if (res.code == 200) {
				this.awardedResearchProduct = res.data.records
			}else{
				this.$message.error(res.data)
			}
		},
		toPage(url) {
			if (!url) return;
			this.$router.push(url);
		}
	}
};
</script>
<style lang="scss" scoped>
	.card-body1{
		min-height: 320px;
	}
</style>
